var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.634,
    height: 17.159,
    viewBox: "0 0 20.634 17.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    fill: "#099cd3",
    d: "M294.777-449.275a2.882 2.882 0 0 1-2.852-2.875A2.882 2.882 0 0 1 294.8-455a2.877 2.877 0 0 1 2.851 2.874 2.877 2.877 0 0 1-2.874 2.852m0-6.919a4.06 4.06 0 0 0-4.051 4.055 4.059 4.059 0 0 0 4.048 4.057 4.053 4.053 0 0 0 4.064-4.039 4.05 4.05 0 0 0-4.061-4.073",
    clipRule: "evenodd",
    "data-name": "Path 406",
    transform: "translate(-290.731 456.194)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    d: "M283-430h30v-30h-30z",
    className: "cls-2",
    "data-name": "Path 405",
    transform: "translate(-283 460)"
  })), /*#__PURE__*/React.createElement("style", null, "\n          .cls-2{fill:#099cd3}\n      "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    fill: "none",
    stroke: "#099cd3",
    strokeLinejoin: "round",
    strokeWidth: "1.2px",
    d: "M288.009-439.253v-3a3.555 3.555 0 0 1 3.7-3.862h6.14c2.907 0 3.395 2.031 3.395 3.862v3.221",
    "data-name": "Path 403",
    transform: "translate(-288.009 456.194)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    clipPath: "url(#clip-path)",
    "data-name": "Group 492",
    transform: "translate(2.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    clipPath: "url(#clip-path-2)",
    "data-name": "Group 491",
    transform: "translate(-7.731 -3.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    d: "M285.731-461.194h18.112v18.112h-18.112z",
    className: "cls-2",
    "data-name": "Path 404",
    transform: "translate(-283 460)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    d: "M0 0H7V1.2H0z",
    className: "cls-2",
    "data-name": "Rectangle 43",
    transform: "translate(13.034 .194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    d: "M0 0H7V1.2H0z",
    className: "cls-2",
    "data-name": "Rectangle 45",
    transform: "translate(13.034 4.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    d: "M0 0H5V1.2H0z",
    className: "cls-2",
    "data-name": "Rectangle 44",
    transform: "translate(13.034 2.194)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contactInfo.78e10e38.svg";
export { ForwardRef as ReactComponent };